import Typography from '@mui/material/Typography'

export const CreateCategoryHeader = () => {
  return <Typography variant='h4'>Create new category</Typography>
}
